import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { Segment, Header, Divider, Tab } from "semantic-ui-react";

import ResourceTable from "../resources/ResourceTable.jsx";
import AddResourceDropDownMenu from "../resources/AddResourceDropdownMenu.jsx";

import {
  USER_RESOURCE_KEYS,
  CORE_RESOURCE_KEYS
} from "../../constants/entity.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ProjectResourcesPanel extends PureComponent {
  static propTypes = {
    project: PropTypes.object.isRequired,
    handleStartStopClick: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "project.resources_panel"
  };

  checkDataValidity = data => {
    return data && data.length > 0;
  };

  buildResourceData = types => {
    const { project } = this.props;

    let data = [];

    for (let i = 0; i < types.length; i++) {
      const type = types[i];
      if (this.checkDataValidity(project[type])) {
        data.push(project[type]);
      }
    }

    return data;
  };

  renderResourceTables = types => {
    const { handleStartStopClick, handleDelete, disabled, copyKey, copy } =
      this.props;

    const data = this.buildResourceData(types);

    if (!data || data.length < 1) {
      return (
        <p className="clear-both">
          {copy(`${copyKey}.no_resources_available`)}
        </p>
      );
    }

    return data.map((item, index) => {
      return (
        <ResourceTable
          key={`resource-table-${index}`}
          data={item}
          handleStartStopClick={handleStartStopClick}
          handleDelete={handleDelete}
          disabled={disabled}
        />
      );
    });
  };

  renderPanes = () => {
    const { copyKey, copy } = this.props;

    const result = [
      {
        menuItem: copy(`${copyKey}.resources_title`),
        render: () => {
          return (
            <Tab.Pane>{this.renderResourceTables(USER_RESOURCE_KEYS)}</Tab.Pane>
          );
        }
      },
      {
        menuItem: copy(`${copyKey}.core_title`),
        render: () => {
          return (
            <Tab.Pane>{this.renderResourceTables(CORE_RESOURCE_KEYS)}</Tab.Pane>
          );
        }
      }
    ];

    return result;
  };

  render() {
    const { project, disabled, copyKey, copy } = this.props;

    return (
      <Segment clearing>
        <div>
          <AddResourceDropDownMenu
            projectId={project.id}
            project={project}
            disabled={disabled}
          />

          <Header as="h3" floated="left">
            {copy(`${copyKey}.title`)}
          </Header>
          <Divider hidden clearing fitted />
        </div>

        <Tab panes={this.renderPanes()} renderActiveOnly={true} />
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ProjectResourcesPanel);
